"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClass = addClass;
exports.byteLength = byteLength;
exports.cleanArray = cleanArray;
exports.createUniqueString = createUniqueString;
exports.debounce = debounce;
exports.deepClone = deepClone;
exports.getQueryObject = getQueryObject;
exports.getVariableType = getVariableType;
exports.hasClass = hasClass;
exports.html2Text = html2Text;
exports.httpRequest = httpRequest;
exports.isEmpty = isEmpty;
exports.numberToIp = numberToIp;
exports.objectMerge = objectMerge;
exports.param = param;
exports.param2Obj = param2Obj;
exports.removeClass = removeClass;
exports.toFix = toFix;
exports.toPercent = toPercent;
exports.toggleClass = toggleClass;
exports.uniqueArr = uniqueArr;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-nan");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
var _typeof2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function objectMerge(target, source) {
  if ((0, _typeof2.default)(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((0, _typeof2.default)(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * [deepClone 深拷贝对象]
 * @param    {Object}   obj [需要被拷贝的对象]
 * @return   {Object}       [拷贝完毕后的对象]
 */
function deepClone(obj) {
  var objType = getVariableType(obj);
  var result;
  if (objType === 'Object') result = {};
  if (objType === 'Array') result = [];
  if (!result) return obj;
  for (var k in obj) {
    var child = obj[k];
    var childType = getVariableType(child);
    var needDeepClone = childType === 'Object' || childType === 'Array';
    if (needDeepClone) {
      result[k] = deepClone(child);
    } else {
      result[k] = child;
    }
  }
  return result;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * [getVariableType 获取变量的准确数据类型]
 * @param    {Object}   varable [变量]
 * @return   {String}           [数据类型,比如: String, Object, Array 等]
 */
function getVariableType(variable) {
  return Number.isNaN(variable) ? NaN : Object.prototype.toString.call(variable).slice(8, -1);
}

/**
 * 保留小数点后2为
 * @param {float} number
 */
function toFix(number) {
  if (number === 0) {
    return 0;
  }
  return (Math.round(number * 100) / 100).toFixed(2);
}

/**
 * 生成百分数，保留小数点后两位
 * @param {float} point
 */
function toPercent(point) {
  if (point === 0) {
    return 0;
  }
  var str = Number(point * 100).toFixed(2);
  str += '%';
  return str;
}

/**
 * 整数转为IP
 * @param {number} number
 */
function numberToIp(number) {
  var ip = '';
  if (number <= 0) {
    return ip;
  }
  var ip3 = number << 0 >>> 24;
  var ip2 = number << 8 >>> 24;
  var ip1 = number << 16 >>> 24;
  var ip0 = number << 24 >>> 24;
  ip += ip3 + '.' + ip2 + '.' + ip1 + '.' + ip0;
  return ip;
}

/**
 * 判断是否为空
 * @param {mixed} data
 */
function isEmpty(data) {
  if (data === null || data === undefined) {
    return true;
  }
  if (Object.prototype.toString.call(data) === '[object String]') {
    return data === '';
  }
  if (Object.prototype.toString.call(data) === '[object Number]') {
    return data === 0;
  }
  if (Object.prototype.toString.call(data) === '[object Array]') {
    return data.length === 0;
  }
  if (Object.prototype.toString.call(data) === '[object Object]') {
    return Object.keys.length === 0 || JSON.stringify(data) === '{}';
  }
}

/**
 * 发起请求
 * @param {Function} request 请求方法
 * @param {String|Number} routeKey 路由参数
 * @param {Object} requestData 请求参数
 * @param {String} failPrefix 错误提示前缀
 */
function httpRequest(request, routeKey, requestData, failPrefix) {
  var callRequest = function callRequest(routeKey, requestData) {
    return routeKey ? request(routeKey, requestData) : request(requestData);
  };
  return new Promise(function (resolve, reject) {
    callRequest(routeKey, requestData).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      var msg = err.msg || err;
      reject({
        code: err.code,
        msg: "".concat(failPrefix || '请求失败', ":").concat(msg)
      });
    });
  });
}